/**
 * Journal — three editorial blog cards linking to /blog/{slug}.
 */
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function HomeJournal({ blog }) {
    return (
        <section className="border-t border-zen-ink/8 bg-zen-surface/60">
            <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-12 sm:py-16">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8">
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.35em] text-zen-olive mb-4">
                            The Journal
                        </p>
                        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-zen-ink leading-[1.05] max-w-2xl">
                            Slow reads on the plant.
                        </h2>
                    </div>
                    <Link
                        to="/blog"
                        className="zen-link text-[12px] uppercase tracking-[0.25em] text-zen-ink-soft hover:text-zen-ink inline-flex items-center gap-2"
                    >
                        All posts <ArrowUpRight size={14} />
                    </Link>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    {blog.slice(0, 3).map((p) => (
                        <Link
                            to={`/blog/${p.slug}`}
                            key={p.slug}
                            data-testid={`home-blog-${p.slug}`}
                            className="group bg-zen-bg border border-zen-ink/10 hover:border-zen-olive/60 hover:-translate-y-1 transition-all duration-500 overflow-hidden"
                        >
                            <div className="aspect-[16/10] overflow-hidden bg-zen-surface">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            </div>
                            <div className="p-7">
                                <p className="text-[10px] uppercase tracking-[0.25em] text-zen-olive mb-3">
                                    {p.read_time}
                                </p>
                                <h3 className="font-serif text-xl text-zen-ink font-light leading-tight mb-3">
                                    {p.title}
                                </h3>
                                <p className="text-sm text-zen-ink-soft leading-relaxed">
                                    {p.excerpt}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
